import { HideableOption } from "../../options/hideable-option";
import { EditModalItem } from "./edit-modal-item";

export class EditModalSection {
    function: string;
    piOptions: HideableOption<number>[];
}
